export const WorkCollaborationPreference = {
  Remote: 'remote',
  Hybrid: 'hybrid',
  Onsite: 'onsite',
} as const;

export const WorkCollaborationPreferenceValues = Object.values(WorkCollaborationPreference);

export type WorkCollaborationPreference =
  (typeof WorkCollaborationPreference)[keyof typeof WorkCollaborationPreference];

export interface SupplierOnboardingStatusDto {
  needsSupplierOnboarding: boolean;
  showAccountLocationStep: boolean;
}

/** Current membership on GET /me (timestamps are ISO strings in JSON). */
export interface MeCurrentMembershipDto {
  id: string;
  role: string;
  accountId: string;
  blockedAt: string | null;
  verifiedAt: string | null;
  supplierOnboardingCompletedAt: string | null;
}

export interface UpdateOperationalLocationDto {
  country: string;
  city: string;
  timeZone: string;
}

/** Payload for POST /me/onboarding - persists profile, optional location, then marks onboarding complete. */
export interface CompleteSupplierOnboardingDto {
  jobTitle: string;
  description: string;
  workCollaborationPreferences: WorkCollaborationPreference[];
  /** Required for account owners when setting company locality (omit for members). */
  operationalLocation?: UpdateOperationalLocationDto;
}
